import { render, staticRenderFns } from "./linkBox.vue?vue&type=template&id=1ac4e490&scoped=true&"
import script from "./linkBox.vue?vue&type=script&lang=js&"
export * from "./linkBox.vue?vue&type=script&lang=js&"
import style0 from "./linkBox.vue?vue&type=style&index=0&id=1ac4e490&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac4e490",
  null
  
)

export default component.exports